export default "__VITE_ASSET__D6BmMa7___"